/**
 * Store compartido de la última lectura GPS.
 * Permite que el MapContainer dibuje el círculo de precisión y centre el mapa
 * cuando cualquier parte de la app obtiene una nueva posición.
 * @module stores/useGeoStore
 */

import { create } from 'zustand'
import type { GeoFix } from '@/hooks/useGeolocation'

interface GeoStore {
  lastFix: GeoFix | null
  followOnNext: boolean
  setLastFix: (fix: GeoFix) => void
  clearFix: () => void
  setFollowOnNext: (v: boolean) => void
}

export const useGeoStore = create<GeoStore>((set) => ({
  lastFix: null,
  followOnNext: false,
  setLastFix: (fix) => set({ lastFix: fix }),
  clearFix: () => set({ lastFix: null }),
  setFollowOnNext: (v) => set({ followOnNext: v }),
}))
